import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';
import {createRequestOption} from '../helpers/request-util';

@Injectable({
  providedIn: 'root'
})
export class ArchivoXmlService {

  public resourceUrl = environment.apiUrl + 'comparendo/archivoXml';
  constructor(public http: HttpClient) { }

  create(archivoXml: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl, archivoXml);
  }

  createUpload(archivoXml: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl + "/createUpload", archivoXml);
  }

  update(archivoXml: any): Observable<any> {
    return this.http.put<any>(this.resourceUrl, archivoXml);
  }

  find(id: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/${id}`);
  }

  query(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceUrl, { params: options});
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`);
  }

  encontrarPorNombreYEliminado(nombre: string): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/${nombre}`);
  }
}
